import React from "react";
import { Container, Row, Col } from "reactstrap";

import UploadPage from "./components/UploadPage";

const BulkUpload = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Registers/Bulk Upload</h3>
        </Col>
      </Row>
      <Row>
        <UploadPage />
      </Row>
    </Container>
  );
};

export default BulkUpload;
